import React, { useState, useEffect } from "react";
import { Container, Row, Tabs, Tab } from "react-bootstrap";
import _ from "lodash"

import { GlobalState } from "contexts/GlobalState";
import useSearch from "hooks/useSearch";
import useFocus from "hooks/useFocus";
import arrow from "assets/img/arrow.png"
import "./style.scss";

export const FacultyFilter = (props) => {
    const [globalSearch, setGlobalSearch] = GlobalState("search");
    const [facultyNames, setFacultyNames] = useState([]);
    const [clickedFaculty, setClickedFaculty] = useState();
    const { searchPrograms } = useSearch();
    const labels = props.labels;
    const needCustomFocus = labels.is_calculator && !Utils.isMobile();
    const { customFocusOnTab, customHandleClick } = useFocus(needCustomFocus, labels);

    useEffect(() => {
        //create the list of faculties and add "all" faculty
        const faculties = labels.nodes.faculty.map(singleFaculty => singleFaculty.field_short_name);
        faculties.unshift(labels.all);
        setFacultyNames(faculties);
        setClickedFaculty(labels.all);
    }, []);

    const handleScroll = (side) => {
        const facultiesTabs = document?.querySelector("#facultiesTabs .nav");
        side === "left" ? facultiesTabs.scrollLeft -= 400 : facultiesTabs.scrollLeft += 400;
    }

    return (
        <Container className={`faculty-filter`}>
            <h3>{labels.want_to_know} {props.adapter}</h3>
            <Row className="faculties-row">
                <button
                    className="scroll-btn"
                    onClick={() => handleScroll("right")}
                    aria-label={labels.horizontalScrollRight}
                >
                    {!Utils.isMobile() ?
                        <img className="scroll-right" src={arrow} alt="scroll right faculty tabs" />
                        : ""}
                </button>

                <div id="facultiesTabs" className="faculties">
                    <Tabs
                        onSelect={customHandleClick}
                        id="fill-tab-example"
                        defaultActiveKey="הכל"
                        onKeyDown={(e) => customFocusOnTab(e, "title_searchResult0")}
                    >
                        {facultyNames.slice(0).reverse().map((item ,index)=>
                            <Tab eventKey={item} title={item}  key={index} >
                            </Tab>)}
                    </Tabs>
                </div>
                <button
                    className="scroll-btn"
                    onKeyDown={(e) => customFocusOnTab(e, "filterBy")}
                    onClick={() => handleScroll("left")}
                    id="scrollLeft"
                    aria-label={labels.horizontalScrollLeft}
                >
                    {!Utils.isMobile() ?
                        <img className="scroll-left" src={arrow} alt="scroll left faculty tabs" />
                        : ""}
                </button>
            </Row>
        </Container>
    )
}